/**
 * Admin bundle initialization
 */
import {initCssSizing} from "../helpers/sizing/sizing";
import {scrollToElement} from "../helpers/scrolling/scrolling";
import {addRememberCollapsibleHandlerToCards} from "../helpers/cards/collapsible";
import {stopLoading} from "../helpers/loading";

const {initFullPageLoading} = require("../helpers/loading");
window._ = require('lodash');

try {
	// Load Jquery
	window.$ = window.jQuery = require('jquery');

	// Load AdminLTE dependencies
	require('overlayscrollbars');
	require('bootstrap');
	require('../../../vendor/almasaeed2010/adminlte/dist/js/adminlte');

} catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Used on handleAjaxError.js and maybe somewhere else
 */
window.scrollToElementNative = scrollToElement;

/**
 * Init loading overlay
 */
initFullPageLoading()

/**
 * Init css sizing variables
 */
initCssSizing()

/**
 * Run this after after dom is loaded and components are initialized
 */
function afterComponentLoadBootstrap() {
	/**
	 * Remove sweetalert 2 styles generated by importing the Js package.
	 * As those are imported on the CSS bundle.
	 */
	document.querySelectorAll('style').forEach(styleTag => {
		if (styleTag.innerHTML.startsWith('.swal2-popup.swal2-toast')) {
			styleTag.remove();
		}
	});

	// Initialize all collapsible cards to add event listener to remember collapsed status
	addRememberCollapsibleHandlerToCards();

	// Hook onto pageshow to detect when the user goes back to a previous page
	window.addEventListener("pageshow", event => {
		if (event.persisted) {
			// Hide loading screens (if any) when coming back to a page
			// that was cached
			stopLoading();
		}
	});

	if ("virtualKeyboard" in navigator) {
		// TODO: Do this properly
		navigator.virtualKeyboard.overlaysContent = true;

		navigator.virtualKeyboard.addEventListener("geometrychange", () => {
			requestAnimationFrame(() => {
				// noinspection JSUnresolvedVariable
				const keyboardRect = navigator.virtualKeyboard.boundingRect;

				if (keyboardRect.height > 10) {
					// Calculate padding height
					const paddingHeight = (keyboardRect.height * (1 / visualViewport.scale));
					// Add to document
					document.body.style.paddingBottom = `${paddingHeight}px`;
					// // And scroll down window by the same ammount
					// window.scroll(0, window.scrollY + paddingHeight);

				} else {
					document.body.style.paddingBottom = `0`;
				}
			})
		})
	}
}


export {afterComponentLoadBootstrap};
